<ng-container *transloco="let t">
    <tui-loader [showLoader]="isLoading() || false" [overlay]="true" [textContent]="contentLoader" class="min-h-full">
        <ng-container *ngIf="order() as order; else notFound">
            @if (sourceType() !== 'prepaid_card') {
                <ng-container *ngIf="order.delivery && order.delivery.shared_link">
                    <div class="card relative !p-0">
                        <tui-loader
                            [overlay]="true"
                            [showLoader]="isLoadingMap()"
                            class="card-content h-[325px] overflow-hidden"
                        >
                            <iframe
                                #orderTrackingIframe
                                class="w-full h-[500px]"
                                sandbox="allow-scripts allow-same-origin"
                                [src]="order.delivery.shared_link"
                                (load)="onLoadMap()"
                            >
                            </iframe>
                        </tui-loader>

                        <button
                            tuiIconButton
                            appearance="secondary-destructive"
                            size="m"
                            icon="svg::arrow-top-right-on-square"
                            class="!absolute top-1 right-1"
                            [routerLink]="orderTrackingUrl()"
                        ></button>
                    </div>
                </ng-container>

                <div class="card card-sm card-shadow">
                    <div class="card-header">
                        <h5 class="card-title">{{ t('order_status') }}</h5>

                        <div class="card-actions">
                            <button tuiButton size="s" appearance="outline" [routerLink]="orderStatusUrl()">
                                {{ t('see_details') }}
                            </button>
                        </div>
                    </div>

                    <div class="card-content">
                        <us-order-state
                            *ngIf="order.states && order.states.length > 0"
                            [item]="order.states[0]"
                            [standalone]="true"
                        >
                        </us-order-state>
                    </div>
                </div>
            }

            @if (topUpInfo(); as info) {
                <div class="card card-sm card-shadow">
                    <div class="card-header">
                        <h5 class="card-title">{{ t('top_up_info') }}</h5>
                    </div>
                    <div class="card-content">
                        <dl>
                            <div>
                                <dt>{{ t('card_code') }}</dt>
                                <dd class="text-right">
                                    <a tuiLink routerLink="/account/treatment-card">{{ info.card_id }}</a>
                                </dd>
                            </div>
                            <div>
                                <dt>{{ t('top_up_amount') }}</dt>
                                <dd class="text-right">
                                    {{ info.total_amount | formatCurrency }}
                                </dd>
                            </div>
                            <div>
                                <dt>{{ t('balance') }}</dt>
                                <dd class="text-right">
                                    {{ info.balance_after | formatCurrency }}
                                </dd>
                            </div>
                        </dl>
                    </div>
                </div>
            }

            <div class="card card-sm card-shadow">
                <div class="card-header">
                    <h5 class="card-title">{{ t('order_info') }}</h5>
                </div>
                <div class="card-content">
                    <dl>
                        <div>
                            <dt>{{ t('order_code') }}</dt>
                            <dd class="text-right">{{ order.order_code }}</dd>
                        </div>
                        <div>
                            <dt>{{ t('order_date') }}</dt>
                            <dd class="text-right">
                                {{
                                    (order.submit_time || order.booking_time || order.created_at)!
                                        | dfnsParseIso
                                        | dfnsFormat: 'p, iiii P'
                                }}
                            </dd>
                        </div>
                        <div *ngIf="!!order.note">
                            <dt>{{ t('note') }}</dt>
                            <dd class="text-right">
                                <div class="prose">
                                    <blockquote>
                                        {{ order.note || '-' }}
                                    </blockquote>
                                </div>
                            </dd>
                        </div>
                    </dl>
                    <div
                        *ngIf="selectDisplayInfoAfterOrder()"
                        class="flex justify-center flex-col gap-1 items-center mt-2"
                    >
                        <div class="content font-semibold">{{ selectContentInfoAfterOrder() }}</div>
                        <div class="contact-info flex">
                            <ng-container *ngIf="contactInfo() as contactInfo">
                                <button *ngIf="contactInfo?.zalo" (click)="handleContact('zalo', contactInfo.zalo)">
                                    <tui-svg src="icon::zalo" class="menu-item-icon-lg mr-[0!important]"></tui-svg>
                                </button>
                                <button
                                    *ngIf="contactInfo?.facebook_messenger"
                                    (click)="handleContact('facebook_messenger', contactInfo.facebook_messenger)"
                                >
                                    <tui-svg
                                        src="icon::facebook-messenger"
                                        class="menu-item-icon-lg mr-[0!important]"
                                    ></tui-svg>
                                </button>
                                <button
                                    *ngIf="contactInfo?.facebook_fanpage"
                                    (click)="handleContact('facebook_fanpage', contactInfo.facebook_fanpage)"
                                >
                                    <tui-svg src="icon::facebook" class="menu-item-icon-lg mr-[0!important]"></tui-svg>
                                </button>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>

            @if (sourceType() !== 'prepaid_card' && !isTopUp()) {
                <us-order-shipping-details [order]="order" [readonly]="true"></us-order-shipping-details>
            }

            <div class="card card-sm card-shadow">
                <div class="card-header">
                    <h5 class="card-title">{{ t('products_list') }}</h5>
                </div>
                <div class="card-content">
                    <us-order-items [order]="order" [readonly]="true"></us-order-items>
                </div>
            </div>

            <div class="card card-sm card-shadow">
                <div class="card-header">
                    <h5 class="card-title">{{ t('total') }}</h5>
                </div>

                <div class="card-content">
                    <ul class="divide-y divide-gray-200 dark:divide-gray-700 text-sm mt-2">
                        <li class="py-3 sm:py-4">
                            <div class="flex items-center justify-between">
                                <span>
                                    {{ 'subtotal' | transloco }}
                                    ({{ order.total_items + ' ' + ('item' | transloco) }})
                                </span>

                                <span class="text-gray-700 mb-px">
                                    {{ order.total_price || 0 | formatCurrency }}
                                </span>
                            </div>
                        </li>

                        <li class="py-3 sm:py-4" *ngIf="order.order_type === OrderType.Delivery">
                            <div class="flex items-center justify-between">
                                <span>
                                    {{ t('delivery_fee') }}
                                    <span class="text-gray-500 font-normal ml-1">
                                        {{ order.delivery?.service_name }}
                                    </span>
                                </span>

                                <span class="text-gray-700 mb-px">
                                    {{ order.delivery?.delivery_fee || 0 | formatCurrency }}
                                </span>
                            </div>
                        </li>

                        <li class="py-3 sm:py-4">
                            <div class="flex items-center justify-between">
                                <span> {{ 'discount' | transloco }} </span>
                                <span class="text-gray-700 mb-px">
                                    {{ order.discount?.price || 0 | formatCurrency }}
                                </span>
                            </div>
                        </li>

                        <li class="py-3 sm:py-4 font-semibold">
                            <div class="flex items-center justify-between">
                                <span> {{ 'total' | transloco }} </span>
                                <span class="text-gray-700 mb-px">
                                    {{ order.grand_total | formatCurrency }}
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            @if (sourceType() !== 'prepaid_card') {
                <div class="card card-sm card-shadow">
                    <div class="card-header">
                        <h5 class="card-title">{{ t('payment_info') }}</h5>
                    </div>

                    <div class="card-content">
                        <div class="flex items-center justify-between space-x-2 mb-4">
                            <div class="py-2 space-x-2">
                                <tui-svg [src]="order.payment_type! | paymentTypeIcon"></tui-svg>
                                <span>{{ t(order.payment_type! | paymentTypeLabel: order.order_type!) }}</span>
                            </div>
                            @if (allowChangePaymentMethod()) {
                                <button
                                    tuiButton
                                    type="button"
                                    size="s"
                                    appearance="outline"
                                    (click)="onShowPaymentMethodsDialog()"
                                >
                                    {{ t('change') }}
                                </button>
                            }
                        </div>

                        <ng-container
                            *ngIf="
                                order.payment_type !== PaymentType.Cash &&
                                order.payment_type !== PaymentType.BankTransfer &&
                                order.current_state === OrderState.PendingPayment
                            "
                        >
                            <div class="mt-5 grid grid-cols-1 md:grid-cols-2 gap-2">
                                <button
                                    tuiButton
                                    size="m"
                                    appearance="outline"
                                    (click)="checkTransactionStatus()"
                                    [showLoader]="isLoading() || false"
                                >
                                    <tui-svg src="svg::check-payment" class="mr-2"></tui-svg>
                                    {{ 'check_transaction_status' | transloco }}
                                </button>
                                @if (payUrl(); as url) {
                                    <a tuiButton size="m" appearance="outline" [href]="url">
                                        <tui-svg src="svg::payment" class="mr-2"></tui-svg>
                                        {{ t('link_payment') }}
                                    </a>
                                }
                            </div>
                        </ng-container>

                        <div
                            *ngIf="
                                order.payment_type === PaymentType.BankTransfer && bankTransferInformation() !== null
                            "
                            class="mt-2 p-4 text-base bg-blue-50 text-gray-700 rounded block ng-star-inserted"
                        >
                            {{ bankTransferInformation() }}
                        </div>
                    </div>
                </div>

                @if (!isTopUp()) {
                    <div class="card card-sm card-shadow">
                        <div class="card-header">
                            <h5 class="card-title">{{ t('order_qrcode') }}</h5>
                        </div>

                        <div class="card-content">
                            <div class="text-center">
                                <us-order-qrcode [order]="order"></us-order-qrcode>

                                <p class="text-xl text-medium font-gray-800">
                                    {{ order.order_code }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-between">
                        <ng-container *ngIf="contactInfo() as contactInfo">
                            <button
                                tuiButton
                                (click)="handleContact('phone', contactInfo.phone)"
                                class="w-[48%]"
                                [size]="'m'"
                            >
                                <tui-svg slot="start" src="svg::shop-2" class="text-white"></tui-svg>&nbsp;
                                {{ 'contact' | transloco }}
                            </button>
                        </ng-container>
                        <tui-hosted-dropdown class="w-[48%]" tuiDropdownLimitWidth="fixed" [content]="dropdown">
                            <button tuiButton [size]="'m'" class="w-full">
                                <tui-svg src="svg::chat-bubble-bottom-center-text" class="text-white"></tui-svg>&nbsp;
                                {{ 'contact_infos' | transloco }}
                            </button>
                        </tui-hosted-dropdown>
                    </div>
                }
            }
        </ng-container>
    </tui-loader>

    <ng-template #dropdown>
        <div class="flex flex-col w-full">
            <ng-container *ngIf="contactInfo() as contactInfo">
                <!-- <button *ngIf="contactInfo.phone !== undefined"
                        (click)="handleContact('phone',contactInfo.phone)"
                        tuiOption>
                    <tui-svg src="icon::phone"
                             class="menu-item-icon-lg"></tui-svg>
                    {{'phone_number.label' | transloco}}
                </button> -->
                <button
                    *ngIf="contactInfo?.zalo"
                    (click)="handleContact('zalo', contactInfo.zalo)"
                    tuiOption
                    class="flex justify-start items-center"
                >
                    <tui-svg src="icon::zalo" class="menu-item-icon-lg"></tui-svg>
                    <span>Zalo</span>
                </button>
                <button
                    *ngIf="contactInfo?.facebook_messenger"
                    (click)="handleContact('facebook_messenger', contactInfo.facebook_messenger)"
                    tuiOption
                    class="flex justify-start items-center"
                >
                    <tui-svg src="icon::facebook-messenger" class="menu-item-icon-lg"></tui-svg>
                    <span>Facebook Messenger</span>
                </button>
                <button
                    *ngIf="contactInfo?.facebook_fanpage"
                    (click)="handleContact('facebook_fanpage', contactInfo.facebook_fanpage)"
                    tuiOption
                    class="flex justify-start items-center"
                >
                    <tui-svg src="icon::facebook" class="menu-item-icon-lg"></tui-svg>
                    <span>Facebook</span>
                </button>
            </ng-container>
        </div>
    </ng-template>
    <ng-template #notFound>
        <div *ngIf="!isLoading()">
            <us-not-found [showHomeBtn]="showHomeBtn()" />
        </div>
    </ng-template>

    <ng-template
        [tuiDialogOptions]="{ label: t('payment_methods'), size: 's' }"
        [(tuiDialog)]="showPaymentMethodsDialog"
    >
        <us-payment-type-options [options]="paymentMethods()" [(value)]="newPaymentType" size="m">
        </us-payment-type-options>

        <button
            tuiButton
            type="button"
            size="m"
            appearance="primary"
            class="mt-4 w-full"
            [disabled]="newPaymentType === null"
            (click)="onChangePaymentMethod()"
        >
            {{ t('confirm') }}
        </button>
    </ng-template>
    <ng-template #contentLoader>
        <tui-avatar *ngIf="shop().logo" [avatarUrl]="shop().logo" size="l" class="mb-4"></tui-avatar>
    </ng-template>
</ng-container>
